const calculateDaysBetween = (from, to) => {
    if (!from || !to) return;
    var millisecondsPerDay = 1000 * 60 * 60 * 24;
    var differenceInMilliseconds = new Date(to).getTime() - new Date(from).getTime();
    return differenceInMilliseconds / millisecondsPerDay;
}

export default calculateDaysBetween;